<template>
  <v-container fluid class="principal-body" color="background" style="height: 100%; overflow-y: auto;">
    <v-row justify="center" style="font-size: 20px">
      <b>{{ $t('Settings') }}</b>
    </v-row>
    <div class="my-view" />
    <v-btn block class="main-btn" style="margin-top: 25px" @click="goToLanding">
      {{ $t('Login.about') }}
    </v-btn>
    <v-btn block class="main-btn" style="margin-top: 25px" @click="goToTutorial">
      {{ 'Tutorial' }}
    </v-btn>
    <v-row>
      <v-col>
        <v-menu offset-y>
          <template #activator="{ on }">
            <v-btn block class="main-btn" style="margin-top: 15px" v-on="on">
              {{ $t('Login.LanguageTitle') }}
            </v-btn>
          </template>
<!--          <v-list flat style="">
            <v-list-item-group no-action>
              <v-list-item 
                v-for="(item,index) in languages"
                :key="index"
                class="option"
                @click="changeLanguage(item.title)">
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>-->
        </v-menu>
      </v-col>
    </v-row>
    <v-btn block class="main-btn" style="margin-top: 25px" @click="goFAQs">
      {{ 'FAQs' }}
    </v-btn>
    <v-btn block class="main-btn" style="margin-top: 25px" @click="goContactUs">
      {{ $t('Contact us') }}
    </v-btn>
  </v-container>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import LocalRepository from "../repositories/LocalRepository";
import SmartRepository from "@/repositories/SmartRepository";
export default {
    name: "Settings",
    data () {
        return {
            languages: [
                { title: this.$t('Catalan') },
                { title: this.$t('Spanish') },
                { title: this.$t('English') },
            ],  
        };
    },
    methods: {
        goFAQs () {
            window.location.replace(Constants.FAQS_URL);
        },
        goContactUs () {
            window.location.replace(Constants.CONTACT_URL);
        },
        goToLanding () {
            window.location.replace(Constants.LANDING_BASE_URL);
        },
        goToTutorial () {
            if (this.$user)
                this.$router.push({name: 'Tutorial', params: {}, replace: true});
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        changeLanguage (lang) {
            let language = '';
            if (lang === 'Catalan' || lang === 'Català' || lang === 'Catalán') language = 'ca';
            if (lang === 'Spanish' || lang === 'Castellà' || lang === 'Español') language = 'es';
            if (lang === 'English' || lang === 'Anglès' || lang === 'Inglés') language = 'en';
            ApiRepository.changeLanguage(language)
                .then(() => {

                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing language'), color: 'error'});
                    console.error(err);
                });
            localStorage.setItem('language', language);
            location.reload();
        },
    }
    
};
</script>

<style scoped>
.my-view{
  content: '';
  width: 80%;
  height: 1px;
  background-color: #0AE7C1 ;
  margin-top: 3%;
  margin-bottom: 3%;
  position: relative;
  transform: translateY(-50%);
  left: 10%;
  right: 10%;
}

.main-btn{
  border: 2px solid rgba(10, 231, 193, 1);
  background-color: transparent;
  outline: none;
}
.option {
  border-radius: 10px;border: 2px solid rgba(10, 231, 193, 1);
  background-color: transparent;
  outline: none;

}

.option:not(:last-child) {
  border-bottom: none;
}

</style>
